import Boundary from "./boundary";

class Cuboid extends Boundary {
    min;
    max;

    constructor(props) {
        super();
        this.min = new THREE.Vector3().fromArray(props.minPos);
        this.max = new THREE.Vector3().fromArray(props.maxPos);
        this.bBox = new THREE.Box3(this.min, this.max);
    }
}

export default Cuboid;
